export default "__VITE_ASSET__BPMOQ$Xa__"